<!-- 计费模式设置 -->
<template>
    <div class='container containerBox'>
        <div style="margin: 20px 0;line-height: 40px;">
            <span class="schema-title">计费模式控制：</span>
            <el-radio v-model="formData.factory_mode" label="1">调试模式</el-radio>
            <el-radio v-model="formData.factory_mode" label="0">正常模式</el-radio>
        </div>
         <div style="margin: 20px 0;line-height: 40px;">
            <span class="schema-title">计费开关控制：</span>
            <el-radio v-model="formData.allow_charging" label="1">允许计费</el-radio>
            <el-radio v-model="formData.allow_charging" label="0">停止计费</el-radio>
        </div>
        <el-button type="primary" size="medium" @click="handleSave">确认控制</el-button>
    </div>
</template>

<script>
import Service from '@/api/Service'
export default {
    name:  'BillingMode',
    data() {
        return {
            formData: {
                factory_mode: "1",    //  是否自动计费（0默认，1自动计费，2手动计费）
                allow_charging: "0",   //  计费开关（0默认，1开，2关
            },
        };
    },

    components: {},

    methods: {
        async handleSave() {
            let res = await Service.controlchargingbypid(this.formData);
            if(res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
            }
        }
    }
}

</script>
<style lang='less' scoped>

</style>